
    import VueUtils from "@/cuties/VueUtils";
    import type { PossessionIdentity } from "cuties-client-components/types/general/UnitIdentity";
    import type { PropType } from "vue";
    import { defineComponent } from "vue";
    import PossessionIdentityBlock from "@/app/components/identity/PossessionIdentityBlock.vue";
    import type PossessionsState from "@/app/components/crafting/PossessionsState";
    import PossessionsLayer from "./crafting/PossessionsLayer";

    export type RequirementsPopupData = {
        allOfPlayerRequirements: PossessionIdentity[];
        allOfConsumes: PossessionIdentity[];
    };

    export default defineComponent({
        name: "RequirementsPopup",
        components: { PossessionIdentityBlock },
        emits: ["close"],
        async mounted() {
            this.possessionsState = await PossessionsLayer.countOwnedIdentitiesIfLoggedIn([
                ...this.requirementsPopupData.allOfConsumes,
                ...this.requirementsPopupData.allOfPlayerRequirements,
            ]);
        },
        props: {
            requirementsPopupData: {
                required: true,
                type: Object as PropType<RequirementsPopupData>,
            },
        },
        computed: {
            isMobile: VueUtils.isMobile,
        },
        data(): {
            possessionsState: PossessionsState | null;
        } {
            return {
                possessionsState: null,
            };
        },
    });
